import { takeLatest, put, call } from 'redux-saga/effects';
import {
    getBrightEdgeApi,
    getDefaultCapsuleApi,
} from 'yoda-interfaces/lib/BrightEdge/BrightEdgeApi';
import {
    BRIGHTEDGE_AUTOPILOT_GET_REQUEST,
    BRIGHTEDGE_AUTOPILOT_GET_SUCCESS,
    BRIGHTEDGE_AUTOPILOT_GET_ERROR,
} from '../actionTypes/BrightEdgeActionTypes';

function* brightEdgeAutopilotSaga(params) {
    try {
        const brightEdgeData = yield call(getBrightEdgeApi, params.payload) || {};

        // When key is -0, fetch default links from the default capsule endpoint
        if (brightEdgeData?.key === '-0') {
            const defaultCapsuleData = yield call(getDefaultCapsuleApi);
            if (defaultCapsuleData) {
                brightEdgeData.config = defaultCapsuleData.config || brightEdgeData.config;
                brightEdgeData.page_group_nodes =
                    defaultCapsuleData.page_group_nodes || brightEdgeData.page_group_nodes;
            }
        }

        yield put({
            type: BRIGHTEDGE_AUTOPILOT_GET_SUCCESS,
            brightEdgeData,
        });
    } catch (error) {
        yield put({ type: BRIGHTEDGE_AUTOPILOT_GET_ERROR, error });
    }
}

const watchBrightEdgeAutopilotRequest = function* watchBrightEdgeAutopilotRequest() {
    yield takeLatest(BRIGHTEDGE_AUTOPILOT_GET_REQUEST, brightEdgeAutopilotSaga);
};

watchBrightEdgeAutopilotRequest.sagaName = 'watchBrightEdgeAutopilotRequest';

export default watchBrightEdgeAutopilotRequest;
